var map = {
	"./About/Index.vue": 16009,
	"./Bgyx/Database/add.vue": 51379,
	"./Bgyx/Database/edit.vue": 7535,
	"./Bgyx/Database/list.vue": 33216,
	"./Home/Det/$id.vue": 64114,
	"./Home/Det/Index.vue": 16903,
	"./Home/Index.vue": 17209,
	"./Home/Se.vue": 54229,
	"./Login/login.vue": 4132,
	"./System/Account/add.vue": 62738,
	"./System/Account/auth.vue": 32605,
	"./System/Account/list.vue": 5631,
	"./System/Bgyx/add.vue": 86928,
	"./System/Bgyx/edit.vue": 55188,
	"./System/Bgyx/list.vue": 4731,
	"./System/Dbfields.vue": 16972,
	"./System/Dbs.vue": 55672,
	"./System/Dict.vue": 42346,
	"./System/Index.vue": 73338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99350;